import { render } from "./CrownIcon.vue?vue&type=template&id=2bc27b93"
import script from "./CrownIcon.vue?vue&type=script&lang=js"
export * from "./CrownIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__